export const networkThemesFeedBasePath = `/network-themes`;
export const networkThemesFeedMatchPath = `${networkThemesFeedBasePath}/:themeId`;

type NetworkThemeFeedPage = (themeId: string) => string;
export const networkThemeFeedPage: NetworkThemeFeedPage = (themeId) => `${networkThemesFeedBasePath}/${themeId}`;
